module.exports = __webpack_public_path__ + "img/help-ot5.2a45ad3c.png";